import { Alert, Button, Modal, Space } from 'antd';
import { FileWordOutlined, PrinterOutlined } from '@ant-design/icons';
import { useMemo, useRef } from 'react';
import { CompanyInfo, QuoteData } from '../calc';
import { buildContractHtml, buildHandoverHtml, contractWordBlob } from '../contract';
import { triggerDownload } from '../api';

interface Props {
  open: boolean;
  onClose: () => void;
  code: string;
  data: QuoteData;
  company: CompanyInfo;
  /** contract = hợp đồng đầy đủ · handover = chỉ biên bản bàn giao & nghiệm thu. */
  kind?: 'contract' | 'handover';
}

/** Xem trước hợp đồng + In / Lưu PDF (hộp in của trình duyệt) + tải bản Word. */
const ContractModal = ({ open, onClose, code, data, company, kind = 'contract' }: Props) => {
  const frame = useRef<HTMLIFrameElement>(null);
  const html = useMemo(
    () =>
      open
        ? (kind === 'handover' ? buildHandoverHtml : buildContractHtml)({ code, data, company })
        : '',
    [open, code, data, company, kind]
  );
  const missing = [
    !company.name && 'tên công ty (Cài đặt)',
    !company.representative && 'người đại diện (Cài đặt)',
    !data.creator.fullName && 'họ tên Creator',
    !data.creator.idNumber && 'số CCCD Creator',
    !data.lines.length && 'thiết bị',
  ].filter(Boolean);
  const fileBase = `${kind === 'handover' ? 'bien-ban-ban-giao' : 'hop-dong'}-${(
    data.contractNo || code
  ).replace(/[^\w-]+/g, '-')}`;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={980}
      title={kind === 'handover' ? 'Biên bản bàn giao và nghiệm thu' : 'Hợp đồng hỗ trợ thiết bị'}
      footer={
        <Space>
          <Button onClick={onClose}>Đóng</Button>
          <Button
            icon={<FileWordOutlined />}
            onClick={() => triggerDownload(contractWordBlob(html), `${fileBase}.doc`)}
          >
            Tải Word
          </Button>
          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => frame.current?.contentWindow?.print()}
          >
            In / Lưu PDF
          </Button>
        </Space>
      }
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <Alert
          type="warning"
          showIcon
          message="Mẫu tham khảo — nhờ luật sư rà soát trước khi dùng chính thức."
          description="Chỗ còn trống in thành dòng chấm để điền tay. Không giữ CCCD gốc của Creator (trái luật) — chỉ xem bản gốc và lưu bản chụp."
        />
        {missing.length > 0 && (
          <Alert type="info" showIcon message={`Còn thiếu: ${missing.join(', ')}.`} />
        )}
        <iframe
          ref={frame}
          title="Xem trước hợp đồng"
          srcDoc={html}
          style={{
            width: '100%',
            height: '65vh',
            border: '1px solid #ddd',
            borderRadius: 8,
            background: '#fff',
          }}
        />
      </Space>
    </Modal>
  );
};

export default ContractModal;
